import React, { useState } from "react";
import "./MilestoneModal.css";
import { getFirestore, updateDoc, doc, serverTimestamp } from "firebase/firestore";
import OktaApp from "../applications/OktaApp";
import GoogleApp from "../applications/GoogleApp";
import SlackApp from "../applications/SlackApp";
import HibobApp from "../applications/HibobApp";
import AsanaApp from "../applications/AsanaApp";
import ServiceNowApp from "../applications/ServiceNowApp";
import BambooHRApp from "../applications/BambooHRApp";
import MicrosoftTeamsApp from "../applications/MicrosoftTeamsApp";
import GuruApp from "../applications/GuruApp";
import MondayApp from "../applications/MondayApp";
import OneLoginApp from "../applications/OneLoginApp";

const MilestoneModal = ({ segment, connectedApps, onClose }) => {
  const [selectedApp, setSelectedApp] = useState(null);
  const [isConfiguring, setIsConfiguring] = useState(false);
  const db = getFirestore();

  const availableApps = connectedApps.filter(
    (app) => app.category === segment.category && !app.connected
  );

  const handleAppSelect = (app) => {
    setSelectedApp(app);
    setIsConfiguring(true);
  };

  const handleBack = () => {
    setSelectedApp(null);
    setIsConfiguring(false);
  };

  const getAppComponent = (appName) => {
    const components = {
      Okta: OktaApp,
      "Google Workspace": GoogleApp,
      Slack: SlackApp,
      Hibob: HibobApp,
      Asana: AsanaApp,
      ServiceNow: ServiceNowApp,
      BambooHR: BambooHRApp,
      "Microsoft Teams": MicrosoftTeamsApp,
      Guru: GuruApp,
      "monday.com": MondayApp,
      "OneLogin": OneLoginApp,
    };
    return components[appName];
  };

  const renderAppGrid = () => (
    <div className="app-grid">
      {availableApps.map((app) => (
        <div
          key={app.id}
          className="app-card"
          onClick={() => handleAppSelect(app)}
        >
          <img src={app.icon} alt={app.name} className="app-icon" />
          <h3>{app.name}</h3>
          <span className={`status-badge ${app.connected ? 'connected' : 'not-connected'}`}>
            {app.connected ? 'Connected' : 'Not Connected'}
          </span>
        </div>
      ))}
    </div>
  );

  const renderAppConfiguration = () => {
    if (!selectedApp) return null;
    const AppComponent = getAppComponent(selectedApp.name);
    return AppComponent ? (
      <div className="app-configuration">
        <button className="back-button" onClick={handleBack}>
          ← Back to Apps
        </button>
        <AppComponent 
          app={selectedApp}
          onConnect={async () => {
            await updateDoc(doc(db, "applications", selectedApp.id), {
              connected: true,
              connectedAt: serverTimestamp()
            });
            onClose();
          }}
        />
      </div>
    ) : (
      <div>Configuration not available for this app</div>
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{segment.label}</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {isConfiguring ? renderAppConfiguration() : renderAppGrid()}
        </div>
      </div>
    </div>
  );
};

export default MilestoneModal;